import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { PetCardsVisibilityService } from "../../../services/pet-cards-visibility.service";

type TabRoute =
  {
    title: string;
    link: string;
    navigateTo: string[];
    active: boolean;
  }

@Component({
  selector: 'cpf-bottom-lists-wrapper',
  templateUrl: './bottom-lists-wrapper.component.html',
  styleUrls: ['./bottom-lists-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BottomListsWrapperComponent implements OnInit {
  @ViewChild('scrollableContent') scrollableContent!: ElementRef;
  tabRoutes: TabRoute[] = [
    {
      title: 'bottom-list-wrapper.invoice',
      link: '/pet/invoice',
      navigateTo: ['calingo', 'pet', 'invoice'],
      active: false
    },
    {
      title: 'bottom-list-wrapper.insurance',
      link: '/pet/insurance',
      navigateTo: ['calingo', 'pet', 'insurance'],
      active: false
    },
    {
      title: 'bottom-list-wrapper.claim',
      link: '/pet/claims',
      navigateTo: ['calingo', 'pet', 'claims'],
      active: false
    },
  ]

  isPetCardsHidden = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private petCardsVisibilityService: PetCardsVisibilityService) {
  }

  ngOnInit(): void {
    this.onRouteChange(this.tabRoutes);

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.onRouteChange(this.tabRoutes);
    });

    this.petCardsVisibilityService.hidePetCards$.subscribe(hidden => {
      this.isPetCardsHidden = hidden;
    })
  }

  onRouteChange(routes: Array<TabRoute>) {
    this.scrollToTop();

    routes.forEach(route => route.active = false);
    const currentRoute = this.router.url;
    const activeRoute = routes.filter(route => currentRoute.indexOf(route.link) > -1).at(-1);

    if (!activeRoute) {
      return
    }
    activeRoute.active = true;
  }

  private scrollToTop(): void {
    if (this.scrollableContent) {
      this.scrollableContent.nativeElement.scrollTop = 0;
    }
  }

  navigateToRoute(routes: Array<TabRoute>, route: TabRoute) {
    if (route.active) {
      return;
    }

    routes.forEach(route => route.active = false);
    route.active = true;

    this.router.navigate(route.navigateTo);
  }

  petCardsVisibilityToggle() {
    this.petCardsVisibilityService.toggle();
  }
}
